import { pageBannerWithTitle } from './PreviewBanner';

/**
* Test mode page banner for event guestside site.
*/
export default pageBannerWithTitle('EventGuestSide_BannerText_TestMode__resx');
